export default "__VITE_ASSET__DWSRB1_T__"